import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import {
	CreativeAdSize,
	CreativePerformance,
	CreativeStats,
	VideoCompletionPercentage
} from '../creative-detail-v2/creative-detail.interface';
import { PATHS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-creative-performance-v1',
	styleUrls: ['./creative-performance-v1.component.css'],
	templateUrl: './creative-performance-v1.component.html'
})
export class CreativePerformanceV1Component implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() key: string;
	@Input() tertiarykey: string;
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() colors: string;
	@Input() colorsconfig: any;
	@Input() legend: any;
	@Input() placeholderimage: any;
	@Input() columnsconfig: any;
	@Input() secondarykey: string;
	@Input() uniqueoverwriteid: string;
	@Input() producttype: string;
	@ViewChild('carousel') carousel: NguCarousel<any>;

	public showLoad = true;
	public graphData: any;
	public hasGraphData = false;
	public carouselOne: NguCarouselConfig;
	public sortedCreatives: CreativePerformance[] = [];
	public hasData = true;
	public displayStats: any;
	public range: string;
	public reloadSubscription;
	public currentCreativeData: any;
	public currentCreativeStats: any;
	public responseData: any;
	public selectedCreative: CreativePerformance;
	public isTelevisionCreative: boolean;
	public columns: any;
	public isRadio: boolean;
	public isOverviewSem: boolean;
	public chartType: string;
	public markerEnabled: boolean;
	public includeEngagements: boolean = false;
	public placeholderImage: string = '/assets/images/no-display-creative.png';
	public allowTelevisionCreative: boolean = false;
	public isR6: boolean;
	public isGam: boolean;
	public isR8: boolean;

	protected colorPalette: ColorPalette;
	protected isVideoCreative = false;
	protected isAudioCreative = false;
	protected creatives: CreativePerformance[] = [];
	protected showOnly = 5;
	protected carouselToken: string;
	protected selectedIndex = 0;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.selectedIndex = 0;
			this.requestData();
			if (this.carousel && this.carousel.reset) {
				this.carousel.reset();
			}
		});
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			point: {
				visible: true
			},
			touch: true,
			velocity: 0.2
		};
	}

	ngOnInit(): void {
		this.legend = typeof this.legend === 'string' ? JSON.parse(decodeURI(this.legend)) : this.legend;
		this.isTelevisionCreative = this.sectiontitle.indexOf('Television Creative') !== -1;
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.columns = this.columnsconfig ? JSON.parse(decodeURI(this.columnsconfig)) : [];
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
		this.isR6 = this.analyticsDataModel.config.version.toUpperCase() == 'R6' ? true : false;
		this.isR8 = this.analyticsDataModel.config.version.toUpperCase() == 'R8' ? true : false;
		this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.isOverviewSem = this.sectiontitle.indexOf('SEM') !== -1;
		if (this.analyticsDataModel.config.partner.directoryName === 'default-r102') {
			(this.chartType = 'spline'), (this.markerEnabled = false);
		}
		this.processLegendData();
		if (!this.isRadio) {
			this.requestData();
		}
	}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		this.selectedCreative = undefined;
	}

	initDataFn(key: NguCarouselStore): void {
		this.carouselToken = key.token;
	}

	processLegendData(): void {
		for (const legendObj of this.legend) {
			legendObj['selected'] = false;
		}
		this.legend[0].selected = true;
	}

	requestData(): void {
		this.hasGraphData = false;
		this.showLoad = true;
		this.hasData = true;
		if (this.sectionclass !== 'dooh-preroll r6-dooh-preroll') {
			this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
				this.showLoad = false;
				if (response.success) {
					this.hasData = true;
					if (this.isR6 && this.isGam && response.data.length > 0) {
						jQuery('div#' + this.uniqueoverwriteid).removeClass('hideWidget');
					} else if (this.isR6 && this.isGam) {
						jQuery('div#' + this.uniqueoverwriteid).addClass('hideWidget');
					}
					this.responseData = response.data;
					this.processResponseData(response.data);
				} else {
					if (this.isR6 && this.isGam) {
						jQuery('div#' + this.uniqueoverwriteid).addClass('hideWidget');
					}
					this.hasData = false;
				}
			});
		} else {
			this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
				this.showLoad = false;
				if (response.success) {
					this.hasData = true;
					if (this.isR6 && this.isGam && response.data.length > 0) {
						jQuery('div#' + this.uniqueoverwriteid).removeClass('hideWidget');
					} else if (this.isR6 && this.isGam) {
						jQuery('div#' + this.uniqueoverwriteid).addClass('hideWidget');
					}
					this.responseData = response.data;
					this.processResponseData(response.data);
				} else {
					if (this.isR6 && this.isGam) {
						jQuery('div#' + this.uniqueoverwriteid).addClass('hideWidget');
					}
					this.hasData = false;
				}
			});
		}
	}
	processResponseData(responseData: any): void {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			const audioCreatives = _.where(this.creatives, { isAudioCreative: true });
			this.isAudioCreative = audioCreatives.length > 0;
			const selectedLegend: any = _.findWhere(this.legend, { selected: true });
			this.graphData = this.isOverviewSem
				? this.getGraphsData(selectedLegend.value)
				: this.generateGraphDataBySelection(selectedLegend.value);
			this.hasGraphData = true;
		} else {
			this.hasData = false;
			this.hasGraphData = false;
			this.creatives = [];
			this.graphData = {};
		}
	}

	getAdData(ad, flag, index): void {
		if (flag) {
			this.showLoad = true;
			this.analyticsService
				.processCustomServiceRequest(this.secondarykey, ad['ad_id'], ad['ad_type'], flag)
				.subscribe((response: any) => {
					this.showLoad = false;
					if (response.data) {
						this.hasData = true;
						if (response.data.creatives_by_date) {
							ad['creativeStats'] = this.mapResponseToCreativeStats(response.data.creatives_by_date);
						}
						ad['graphData'] = this.generateGraphDataByCreative(ad['creativeStats']);
						return ad;
					} else {
						this.hasData = false;
					}
				});
		}
	}

	processSelectedLegendItem(legendItem: any): void {
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}
		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		selectedLegend.selected = true;
		this.graphData = this.isOverviewSem
			? this.getGraphsData(selectedLegend.value)
			: this.generateGraphDataBySelection(selectedLegend.value);
	}

	moveToSlide(): void {
		this.carousel.moveTo(2, false);
	}

	movetoNextCarousel(index: number): void {
		this.carousel.moveTo(index, false);
		EmitterService.get('PLAY_SELECTED_VIDEO').emit(this.sortedCreatives[index]);
	}

	chartHover(eventObj: any): void {
		const index = eventObj.index;
		const shouldToggle = eventObj.toggle;
		const carouselItemsDiv = jQuery(`.${this.sectionclass} .carousel-points-container`);
		const liele = jQuery(carouselItemsDiv).find('li');
		for (const ele of liele) {
			jQuery(ele).removeClass('hoverEffect');
		}
		if (index !== -1) {
			const selectedEle = jQuery(liele)[index];
			if (shouldToggle) {
				jQuery(selectedEle).addClass('hoverEffect');
			}
		}
	}

	mapResponseDataToInterface(responseData: any): CreativePerformance[] {
		let creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: any = {};
			let location = '';
			const siteLinksArr = [];
			const structuredSnippetExtnArr = [];
			const calloutsExtnArr = [];
			let locationObj = {};
			let siteLinks = [];
			let structuredSnippetExtn = [];
			let calloutsExtn = [];
			const networkInfoArray = [];
			creativeObj.absTopImpressionRate = UtilityService.isUndefinedOrNull(response.abs_top_impression_share)
				? 0
				: parseFloat(response.abs_top_impression_share);
			creativeObj.absTopImpression = UtilityService.isUndefinedOrNull(response.top_impression_share)
				? 0
				: parseFloat(response.top_impression_share);
			creativeObj.creativeName = response.creative_name
				? response.creative_name
				: response.ad_headline
				? response.ad_headline
				: response.name;
			creativeObj.ad_title = UtilityService.isUndefinedOrNull(response.ad_title)
				? ''
				: response.ad_title == ''
				? ''
				: response.ad_title;
			creativeObj.versionId = UtilityService.isUndefinedOrNull(response.cup_version_id)
				? 0
				: parseFloat(response.cup_version_id);
			creativeObj.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			if (this.includeEngagements) {
				creativeObj.engagements = UtilityService.isUndefinedOrNull(response.engagements)
					? 0
					: parseFloat(response.engagements);
				creativeObj.likes = UtilityService.isUndefinedOrNull(response.likes) ? 0 : parseFloat(response.likes);
				creativeObj.shares = UtilityService.isUndefinedOrNull(response.shares) ? 0 : parseFloat(response.shares);
				creativeObj.saves = UtilityService.isUndefinedOrNull(response.saves) ? 0 : parseFloat(response.saves);
				creativeObj.comments = UtilityService.isUndefinedOrNull(response.comments) ? 0 : parseFloat(response.comments);
				creativeObj.reactions = UtilityService.isUndefinedOrNull(response.reactions)
					? 0
					: parseFloat(response.reactions);
			}

			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			creativeObj.adInteractions = UtilityService.isUndefinedOrNull(response.ad_interactions)
				? 0
				: parseFloat(response.ad_interactions);
			creativeObj.adInteractionRate = UtilityService.isUndefinedOrNull(response.interaction_rate)
				? 0
				: parseFloat(response.interaction_rate);
			creativeObj.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			creativeObj.clickRate = UtilityService.isUndefinedOrNull(response.click_rate)
				? UtilityService.isUndefinedOrNull(response.clickthroughrate)
					? creativeObj.impressions > 0
						? ((creativeObj.clicks / creativeObj.impressions) * 100).toFixed(2)
						: 0
					: parseFloat(response.clickthroughrate)
				: parseFloat(response.click_rate);
			creativeObj.individualImpressions = response.individual_impressions
				? parseFloat(response.individual_impressions)
				: null;
			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			creativeObj.exposures = UtilityService.isUndefinedOrNull(response.exposures) ? 0 : parseFloat(response.exposures);
			creativeObj.zones = UtilityService.isUndefinedOrNull(response.zones) ? 0 : parseFloat(response.zones);
			creativeObj.enablePreviewContent = false;
			// TODO: Change logic on figuring out if creative is ctv or preroll
			creativeObj.callExtension = response && response.call_extn ? JSON.parse(response.call_extn)[0][1] : '';
			creativeObj.isCtv = this.sectiontitle.indexOf('CTV') !== -1 || this.sectiontitle.indexOf('Connected TV') !== -1;
			creativeObj.isSocial = this.sectiontitle.indexOf('Social') !== -1;
			creativeObj.isTelevision = this.sectiontitle.indexOf('Television Creative') !== -1;
			if (response.network_for_creatives) {
				const networkInfo = response.network_for_creatives;
				for (const item of networkInfo) {
					if (item.network_url !== '') {
						networkInfoArray.push({
							logo: item.network_url ? item.network_url : '',
							name: item.friendly_name ? item.friendly_name : ''
						});
					} else if (item.network_url === '') {
						networkInfoArray.push({
							logo: '',
							marphedlogo: item.friendly_name ? item.friendly_name.split(/\s+/).slice(0, 4).join(' ') : '',
							name: item.friendly_name ? item.friendly_name : ''
						});
					}
				}
			}
			creativeObj.networkData = networkInfoArray;
			const locationArr = [];
			if (response.location_extn) {
				locationObj = JSON.parse(response.location_extn)[0];
				for (const prop in locationObj) {
					if (parseInt(prop, 10) > 1 && parseInt(prop, 10) < 8) {
						locationArr.push(locationObj[prop]);
					}
				}
				location = locationArr.join(', ');
				creativeObj.location = location;
			}
			try {
				creativeObj.url = typeof response.url == 'string' ? response.url : JSON.parse(response.url)[0];
			} catch (error) {
				creativeObj.url = response.url;
			}
			creativeObj.adHeadline = UtilityService.isUndefinedOrNull(response.ad_headline)
				? ''
				: response.ad_headline === ''
				? ' '
				: response.ad_headline;
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.avgPosition = parseFloat(response.avg_position);
			creativeObj.adgroup_name = UtilityService.isUndefinedOrNull(response.adgroup_name) ? '' : response.adgroup_name;
			creativeObj.adgroup_id = UtilityService.isUndefinedOrNull(response.adgroup_id) ? '' : response.adgroup_id;
			creativeObj.ad_id = UtilityService.isUndefinedOrNull(response.ad_id) ? '' : response.ad_id;
			creativeObj.ad_type = UtilityService.isUndefinedOrNull(response.ad_type) ? '' : response.ad_type;
			creativeObj.final_url = UtilityService.isUndefinedOrNull(response.creative_final_urls)
				? ''
				: response.creative_final_urls;
			creativeObj.ad_description = UtilityService.isUndefinedOrNull(response.ad_description)
				? ''
				: response.ad_description;
			creativeObj.top_impression_share = parseFloat(response.top_impression_share);
			creativeObj.abs_top_impression_share = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpressionShare = parseFloat(response.top_impression_share).toFixed(2);
			creativeObj.absTopImpressionShare = parseFloat(response.abs_top_impression_share).toFixed(2);
			creativeObj.description = UtilityService.isUndefinedOrNull(response.description) ? '' : response.description;
			const temCreativeDesc = creativeObj.description.split('|');
			if (temCreativeDesc.length > 1) {
				creativeObj.description = temCreativeDesc;
			}
			if (response.sitelink_extn) {
				siteLinks = JSON.parse(response.sitelink_extn);
				for (const item of siteLinks) {
					siteLinksArr.push({
						description: `${item['3'] || ''} ${item['4'] || ''}`,
						heading: item['1'],
						link: item['5'][0]
					});
				}
			}
			if (response.structuredsnippet_extn) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] !== '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.callouts_extn) {
				calloutsExtn = JSON.parse(response.callouts_extn);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}
			creativeObj.isIframeExpired = response.is_iframe_expired;
			creativeObj.snapshotImage = response.snapshot_path;
			creativeObj.hasSnapshotImage = !UtilityService.isUndefinedOrNull(response.snapshot_path);
			// creativeObj.isVideoCreative = !UtilityService.isUndefinedOrNull(response.video_url);
			creativeObj.isVideoCreative =
				!UtilityService.isUndefinedOrNull(response.video_url) || response.is_video_creative == 'video' ? true : false;

			creativeObj.isAudioCreative =
				this.sectiontitle.indexOf('Audio') !== -1 && !UtilityService.isUndefinedOrNull(response.audio_url);
			if (creativeObj.isSocial) {
				creativeObj.creativeThumbnail =
					response.creative_thumbnail_image && response.creative_thumbnail_image !== ''
						? decodeURIComponent(
								response.creative_thumbnail_image.slice(
									response.creative_thumbnail_image.includes('http')
										? response.creative_thumbnail_image.lastIndexOf('http')
										: 0
								)
						  )
						: null;
				UtilityService.checkImageURLExpired(creativeObj.creativeThumbnail).then((exists) => {
					if (!exists) {
						creativeObj.creativeThumbnail = null;
					}
				});
			} else {
				creativeObj.creativeThumbnail = response.creative_thumbnail_image
					? !UtilityService.checkEncodeURI(response.creative_thumbnail_image)
						? encodeURI(response.creative_thumbnail_image)
						: response.creative_thumbnail_image
					: this.placeholderImage;
			}
			if (creativeObj.isVideoCreative || creativeObj.isAudioCreative) {
				if (creativeObj.isVideoCreative) {
					creativeObj.creativeThumbnail =
						!creativeObj.isSocial && response.thumbnail_image
							? response.thumbnail_image
							: creativeObj.isSocial
							? creativeObj.creativeThumbnail
							: response.creative_thumbnail_image;
					creativeObj.creativeVideo = response.video_url;
					creativeObj.mp4 = response.mp4;
				}
				if (creativeObj.isAudioCreative) {
					creativeObj.audioURL = response.audio_url;
				}

				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
					? UtilityService.isUndefinedOrNull(response['100_percent_rate'])
						? 0
						: parseFloat(response['100_percent_rate']).toFixed(2)
					: parseFloat(response.completion_rate).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
					? UtilityService.isUndefinedOrNull(response['100_percent_value'])
						? 0
						: parseInt(response['100_percent_value'], 10)
					: parseInt(response.completion_value, 10);
			}
			if (response['25_percent_rate'] > 0) {
				creativeObj.percentValue100 = response['100_percent_value'];
				creativeObj.percentRate100 = response['100_percent_rate'];
				creativeObj.percentValue75 = response['75_percent_value'];
				creativeObj.percentRate75 = response['75_percent_rate'];
				creativeObj.percentValue50 = response['50_percent_value'];
				creativeObj.percentRate50 = response['50_percent_rate'];
				creativeObj.percentValue25 = response['25_percent_value'];
				creativeObj.percentRate25 = response['25_percent_rate'];
			}
			if (response.creatives_by_ads) {
				creativeObj.adSizes = !creativeObj.isVideoCreative
					? this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : [])
					: ({} as { string: CreativeAdSize });
				creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			}
			if (response.creatives_by_date) {
				creativeObj.creativeStats = this.mapResponseToCreativeStats(response.creatives_by_date);
			}
			if (response['25_percent_rate'] > 0) {
				creativeObj.percentValue100 = response['100_percent_value'];
				creativeObj.percentRate100 = response['100_percent_rate'];
				creativeObj.percentValue75 = response['75_percent_value'];
				creativeObj.percentRate75 = response['75_percent_rate'];
				creativeObj.percentValue50 = response['50_percent_value'];
				creativeObj.percentRate50 = response['50_percent_rate'];
				creativeObj.percentValue25 = response['25_percent_value'];
				creativeObj.percentRate25 = response['25_percent_rate'];
			}
			creativeObj.graphData = this.generateGraphDataByCreative(creativeObj.creativeStats);

			if (response.callouts_extn_attribute_values) {
				calloutsExtn = JSON.parse(response.callouts_extn_attribute_values);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}

			if (response.structuredsnippet_extn_attribute_values) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn_attribute_values);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] != '' ? item['2'].join(', ') : item['2']
					});
				}
			}

			siteLinks =
				!UtilityService.isUndefinedOrNull(response.sitelink_extn_attribute_values) &&
				response.sitelink_extn_attribute_values !== ''
					? JSON.parse(response.sitelink_extn_attribute_values)
					: [];

			for (const item of siteLinks) {
				siteLinksArr.push({
					heading: item['1'] || '',
					description: (item['3'] || '') + ' ' + (item['4'] || ''),
					link: item['5'][0] || ''
				});
			}

			locationObj =
				!UtilityService.isUndefinedOrNull(response.location_extn_attribute_values) &&
				response.location_extn_attribute_values !== ''
					? JSON.parse(response.location_extn_attribute_values.replaceAll('\\"', '"'))[0]
					: {};
			for (let prop in locationObj) {
				if (parseInt(prop) > 1 && parseInt(prop) < 8) {
					locationArr.push(locationObj[prop]);
				}
			}
			location = locationArr.join(', ');
			creativeObj.location = location;

			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.siteLinks = siteLinksArr;

			creativeObj.responsiveAdTitle = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title.replaceAll(' "', ' ').replaceAll('" ', ' '))
				: [];
			creativeObj.responsiveAdDescription = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title.replaceAll(' "', ' ').replaceAll('" ', ' '))
				: [];

			if (creativeObj.ad_type == 'RESPONSIVE_SEARCH_AD') {
				creativeObj.description = [];
				creativeObj.adHeadline =
					creativeObj.responsiveAdTitle.length > 1
						? creativeObj.responsiveAdTitle[0]['text'] +
						  ' + ' +
						  (creativeObj.responsiveAdTitle.length - 1) +
						  ' more headlines'
						: creativeObj.responsiveAdTitle.length == 1
						? creativeObj.responsiveAdTitle[0]['text']
						: '';
				creativeObj.responsiveAdDescription.forEach((item) => creativeObj.description.push(item['text']));
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.toUpperCase().includes('DYNAMIC')) {
				creativeObj.description = [];
				creativeObj.adHeadline = 'Dynamically generated headline';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				creativeObj.description.push(descpt1, descpt2);
				creativeObj.url = 'Dynamically generated display URL';
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.toUpperCase().includes('CALL_ONLY_AD')) {
				creativeObj.description = [];
				creativeObj.adHeadline = response.scaa_headline
					? response.scaa_headline.substring(0, 30)
					: response.headline
					? response.headline.substring(0, 30)
					: '';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				creativeObj.description.push(descpt1, descpt2);
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_display_url)
					? UtilityService.isUndefinedOrNull(response.display_url)
						? ''
						: response.display_url
					: response.scaa_display_url;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			} else if (creativeObj.ad_type.length > 0) {
				let ad_headlines = [];
				creativeObj.description = [];
				ad_headlines.push(
					response.scaa_headline_part1
						? response.scaa_headline_part1.substring(0, 30)
						: response.headline_part1
						? response.headline_part1.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part2
						? response.scaa_headline_part2.substring(0, 30)
						: response.headline_part2
						? response.headline_part2.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part3
						? response.scaa_headline_part3.substring(0, 30)
						: response.headline_part3
						? response.headline_part3.substring(0, 30)
						: ''
				);
				creativeObj.adHeadline = ad_headlines.join(' | ');
				creativeObj.description.push(
					response.scaa_description
						? response.scaa_description.substring(0, 90)
						: response.description
						? response.description.substring(0, 90)
						: ''
				);
				creativeObj.url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
				creativeObj.callExtension =
					response && response.call_extn_attribute_values
						? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
						: '';
			}

			creativePerformances.push(creativeObj);
		}

		let temp = [];

		if (this.isOverviewSem) {
			const formattedData = this.groupArrayOfObjectsByAdgroup(creativePerformances, 'adgroup_id');
			let adgroup_ids = Object.keys(formattedData);
			adgroup_ids.forEach((id, index) => {
				let eachAdgroup = formattedData[id];
				let ads = [];
				let combinations = [];
				eachAdgroup.forEach((element) => {
					if (element.ad_type != null && element.ad_type !== 'RESPONSIVE_SEARCH_AD' && element.ad_type !== '') {
						element.url = element.url
							? element.url.substring(
									element.url.indexOf('http') > -1
										? element.url.indexOf('http')
										: element.url.indexOf('www.') > -1
										? element.url.indexOf('www.')
										: 0,
									element.url.indexOf('"]')
							  )
							: '';
						ads.push(element);
					} else {
						if (element.ad_type == 'RESPONSIVE_SEARCH_AD') {
							element.url = element.url.substring(
								element.url.indexOf('http') > -1
									? element.url.indexOf('http')
									: element.url.indexOf('www.') > -1
									? element.url.indexOf('www.')
									: 0,
								element.url.indexOf('"]')
							);
							ads.push(element);
						}
					}
				});
				temp.push(...ads);
			});
			creativePerformances = temp;
		}

		return creativePerformances;
	}

	groupArrayOfObjectsByAdgroup(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	previewCreative(creativeIndex: number): void {
		this.selectedCreative = this.sortedCreatives[creativeIndex];
		this.modalService.open('creative-preview-v1_' + this.key);
	}

	closeCreativePreview(modalId: string): void {
		this.modalService.close(modalId);
		this.selectedCreative = undefined;
	}

	getGraphsData(selectionItem) {
		const sortedCreatives = this.sortCreativesBySelection(selectionItem);
		let ad_ids = [];
		sortedCreatives.forEach((item) => {
			if (!item.creativeStats) ad_ids.push(item['ad_id']);
		});
		if (ad_ids.length > 0) {
			this.analyticsService
				.processCustomServiceRequest(this.tertiarykey, null, null, null, ad_ids)
				.subscribe((response: any) => {
					this.showLoad = true;
					if (response.success) {
						let count = 0;
						this.showLoad = false;
						this.creatives.forEach((item) => {
							let id = ad_ids.find((id) => id == item['ad_id']);
							if (id) {
								count += 1;
								item.creativeStats = this.mapResponseToCreativeStats(response.data[id]['creatives_by_date']);
								item.graphData = this.generateGraphDataByCreative(item.creativeStats);
							}
							if (count == ad_ids.length) {
								this.graphData = this.generateGraphDataBySelection(selectionItem);
								return this.graphData;
							}
						});
					}
				});
		}
	}

	protected sortCreativesBySelection(selectionItem: string): any[] {
		const sortedCreatives = _.sortBy(this.creatives, selectionItem).reverse();
		return sortedCreatives.splice(0, this.showOnly);
	}

	protected generateGraphDataBySelection(selectionItem: any): any {
		const sortedCreatives = this.sortCreativesBySelection(selectionItem);
		const series = [];
		let length = this.sortedCreatives.length;
		for (let i = 0; i < sortedCreatives.length; i++) {
			const seriesObj: any = {};
			seriesObj['name'] = sortedCreatives[i].creativeName;
			seriesObj['id'] = sortedCreatives[i].versionId;
			seriesObj['data'] = sortedCreatives[i].graphData[selectionItem];
			seriesObj['color'] = this.getColorFromColorConfig(i, 1);
			sortedCreatives[i].color = seriesObj['color'];
			seriesObj['zIndex'] = length;
			series.push(seriesObj);
			length--;
		}
		const categories = sortedCreatives.length > 0 ? sortedCreatives[0].graphData.dates : [];
		const graphData = { series, categories };
		this.sortedCreatives = _.compact(sortedCreatives);
		this.currentCreativeData = this.sortedCreatives[this.selectedIndex];
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);
		const keys = [];
		// tslint:disable-next-line: forin
		for (const key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			}
			keys.push({ name: key, value: this.currentCreativeData[key] });
		}
		this.currentCreativeStats = keys;

		return graphData;
	}

	protected generateGraphDataByCreative(creativeStats: CreativeStats[]): any {
		const dates = _.pluck(creativeStats, 'date');
		const impressions = _.pluck(creativeStats, 'impressions');
		const clicks = _.pluck(creativeStats, 'clicks');
		const engagements = _.pluck(creativeStats, 'engagements');
		const interactions = _.pluck(creativeStats, 'adInteractions');
		const completions = _.pluck(creativeStats, 'completions');
		const clickRate = _.pluck(creativeStats, 'clickRate');
		const avgPosition = _.pluck(creativeStats, 'avgPosition');
		const exposures = _.pluck(creativeStats, 'exposures');

		const graphData = {
			adInteractions: interactions,
			avgPosition,
			clickRate,
			clicks,
			completions,
			dates,
			exposures,
			impressions,
			engagements
		};
		return graphData;
	}

	protected getTotalSumByProperty(creativeStats: CreativeStats[], property: string): number {
		const array = _.pluck(creativeStats, property);
		const totalSum = UtilityService.calculateSumFromArray(array);
		return totalSum;
	}

	protected mapResponseToCreativeStats(responseData: any): CreativeStats[] {
		const creativeStatsArray: CreativeStats[] = [];
		for (const response of responseData) {
			const creativeStatsObj: CreativeStats = {} as CreativeStats;
			creativeStatsObj.date = moment(response.date).format('MM-DD-YYYY');
			creativeStatsObj.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? 0 : parseFloat(response.clicks);
			creativeStatsObj.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? 0
				: parseFloat(response.impressions);
			if (this.includeEngagements) {
				creativeStatsObj.engagements = UtilityService.isUndefinedOrNull(response.engagements)
					? 0
					: parseFloat(response.engagements);
			}

			creativeStatsObj.adInteractions = UtilityService.isUndefinedOrNull(response.ad_interactions)
				? 0
				: parseFloat(response.ad_interactions);
			creativeStatsObj.completions = UtilityService.isUndefinedOrNull(response['100_percent_value'])
				? 0
				: parseFloat(response['100_percent_value']);
			creativeStatsObj.avgPosition = UtilityService.isUndefinedOrNull(response.avg_position)
				? 0
				: parseFloat(response.avg_position);
			creativeStatsObj.clickRate = UtilityService.isUndefinedOrNull(response.click_rate)
				? parseFloat(response.clickthroughrate)
				: parseFloat(response.click_rate);
			creativeStatsObj.exposures = UtilityService.isUndefinedOrNull(response.exposures)
				? 0
				: parseFloat(response.exposures);
			creativeStatsArray.push(creativeStatsObj);
		}
		return creativeStatsArray;
	}

	protected mapResponseToAdSizes(responseData: any): any {
		const creativeAdSizeObj: { string: CreativeAdSize } = {} as { string: CreativeAdSize };
		for (const response of responseData) {
			const adSizeObj: CreativeAdSize = {} as CreativeAdSize;
			adSizeObj.adSize = response.ad_size;
			adSizeObj.creativeThumbnail = !UtilityService.checkEncodeURI(response.creative_image)
				? encodeURI(response.creative_image)
				: response.creative_image;
			adSizeObj.cupVersionId = response.cup_version_id;
			creativeAdSizeObj[adSizeObj.adSize] = adSizeObj;
		}
		return creativeAdSizeObj;
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const availableColorsLength = _.values(this.colorsconfig).length;
		const colorIndex = index % availableColorsLength;
		const colorConfig: ColorConfig = this.colorsconfig[colorIndex];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}

	protected isFloat(n: any): boolean {
		return Number(n) === n && n % 1 !== 0;
	}
}
